<template>
  <div v-if="user.id">
    <ClientIndex />
  </div>
</template>

<script>
import ClientIndex from '@/components/hr/client-index.vue'

import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    ClientIndex
  },
  created () {
  },
  watch: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  data: function() {
    return { }
  },
}
</script>

